(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-list-tiles"] && !Shopify.designMode) return;
  try {
    

  function initCollectionSliders() {
    document.querySelectorAll('.collection-list-tiles-section .plp-product-imgs-group.has-slider')
      .forEach(slider => {
        if (!slider.flickityInstance) {
          const flkty = new Flickity(slider, {
            cellAlign: 'left',
            contain: true,
            pageDots: true,
            prevNextButtons: false, // optional for PLP thumbnails
            draggable: true,
            imagesLoaded: true   // 👈 ensures layout waits for images
          });
          slider.flickityInstance = flkty;

          // 👇 Safety refresh when all images inside slider load
          const imgs = slider.querySelectorAll("img");
          let loadedCount = 0;
          imgs.forEach(img => {
            if (img.complete) {
              loadedCount++;
            } else {
              img.addEventListener("load", () => {
                loadedCount++;
                if (loadedCount === imgs.length) {
                  flkty.resize();
                }
              });
              img.addEventListener("error", () => {
                loadedCount++;
                if (loadedCount === imgs.length) {
                  flkty.resize();
                }
              });
            }
          });

          // If they were all already cached
          if (loadedCount === imgs.length) {
            flkty.resize();
          }
        }
      });
  }
  function destroyCollectionFlicktySlider() {
    return new Promise(resolve => {
      const sliders = document.querySelectorAll(".collection-list-tiles-section .plp-product-imgs-group.has-slider");
      sliders.forEach(slider => {
        if (slider.flickityInstance) {
          slider.flickityInstance.destroy();
          slider.flickityInstance = null;
        }
      });
      resolve("destroyed");
    });
  }

  // Initial run after DOM is ready
  document.addEventListener("DOMContentLoaded", function() {
    initCollectionSliders();
  });

  document.addEventListener('DOMContentLoaded', function () {
    const showMoreBtn = document.getElementById('showMoreBtn') || document.getElementById('showMoreBtns');
    if (showMoreBtn) {
      showMoreBtn.addEventListener('click', function () {
        const productSection = showMoreBtn.closest('.collection-list-tiles-section');
        if (productSection) {
          const hiddenProductCards = productSection.querySelectorAll('.hidden-product');
          hiddenProductCards.forEach(card => {
            card.style.display = 'block';
          });
          showMoreBtn.style.display = 'none';
          //
          destroyCollectionFlicktySlider()
            .then(() => {
              initCollectionSliders();
            })
            .catch(err => console.error("Flickity reset failed:", err));
        }
      });
    }
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["CP-recently-viewed"] && !Shopify.designMode) return;
  try {
    

/* === Utility: Wait for element to appear === */
function waitForElement(selector, callback, checkInterval = 200, timeout = 8000) {
  const start = Date.now();
  const timer = setInterval(() => {
    const els = document.querySelectorAll(selector);
    if (els.length > 0) {
      clearInterval(timer);
      callback(els);
    } else if (Date.now() - start > timeout) {
      clearInterval(timer);
      console.warn('[waitForElement] Timeout: no match for', selector);
    }
  }, checkInterval);
}


/* === Load Splide & Flickity === */
(function ensureLibraries() {
  if (!window.Splide) {
    const s=document.createElement('script');
    s.src='https://cdn.jsdelivr.net/npm/@splidejs/splide@4.1.4/dist/js/splide.min.js';
    document.head.appendChild(s);
    const c=document.createElement('link');
    c.rel='stylesheet';
    c.href='https://cdn.jsdelivr.net/npm/@splidejs/splide@4.1.4/dist/css/splide.min.css';
    document.head.appendChild(c);
  }
  if (!window.Flickity) {
    const f=document.createElement('script');
    f.src='https://cdn.jsdelivr.net/npm/flickity@2.3.0/dist/flickity.pkgd.min.js';
    document.head.appendChild(f);
    const fcss=document.createElement('link');
    fcss.rel='stylesheet';
    fcss.href='https://cdn.jsdelivr.net/npm/flickity@2.3.0/dist/flickity.min.css';
    document.head.appendChild(fcss);
  }
})();

/* === Helpers === */
function RV_readHandles(){
  try { return JSON.parse(localStorage.getItem('cp_recent_handles')||'[]'); }
  catch(e){ return []; }
}
function RV_saveHandle(handle){
  if(!handle) return;
  let list=RV_readHandles();
  list=[handle,...list.filter(h=>h!==handle)];
  localStorage.setItem('cp_recent_handles',JSON.stringify(list.slice(0,20)));
}

/* === Flickity Init === 
function initRecentFlickity(){
  document.querySelectorAll('.plp-product-imgs-group.has-slider:not(.flickity-enabled)').forEach(el=>{
    if(window.Flickity && !el.flickityInstance){
      el.flickityInstance=new Flickity(el,{
        cellAlign:'left',
        contain:true,
        pageDots:true,
        prevNextButtons:false,
        wrapAround:true
      });
    }
  });
}
*/
/* === Initialize Flickity sliders inside product cards === */
function initRecentSliders(elements) {
  if (!window.Flickity) {
    console.warn('[initRecentSliders] Flickity not loaded yet.');
    setTimeout(() => initRecentSliders(elements), 300);
    return;
  }

  elements.forEach(slider => {
    if (slider.classList.contains('flickity-enabled')) return;
    try {
      new Flickity(slider, {
        cellAlign: 'left',
        contain: true,
        pageDots: true,
        prevNextButtons: true,
        adaptiveHeight: true,
        wrapAround: false,
        groupCells: false,
      });
      console.debug('[Flickity] initialized on', slider);
    } catch (err) {
      console.error('[Flickity] init error:', err);
    }
  });
}

/* === Build Recently Viewed === 
async function RV_mountOne(root){
  const list=root.querySelector('.cp-new-recs_list');
  if(!list) return;
  list.innerHTML='';
  let handles=RV_readHandles().filter(Boolean);
  const current=window.meta?.product?.handle||null;
  if(current) handles=handles.filter(h=>h!==current);
  handles=[...new Set(handles)].slice(0,20);

  if(!handles.length){ root.style.display='none'; return; }
  root.style.display='';

  const cards=await Promise.all(handles.map(async h=>{
    try{
      const res=await fetch(`/products/${encodeURIComponent(h)}?view=recent-card`);
      if(!res.ok) return null;
      return await res.text();
    }catch{return null;}
  }));

    let count=0;
    cards.forEach(html => {
        if (!html || html.includes('<script') || html.includes('<html')) return;
        const tmp = document.createElement('div');
        tmp.innerHTML = html.trim();
        const card = tmp.firstElementChild;
        if (!card) return;
        const li = document.createElement('li');
        li.className = 'splide__slide';
        li.appendChild(card);
        list.appendChild(li);
    });


  if(!count){ root.style.display='none'; return; }

  // === Outer Splide ===
  function initSplide(){
    if(!window.Splide) return setTimeout(initSplide,100);
    const slider=root.querySelector('.splide');
    if(!slider) return;
    if(slider._splide) slider._splide.destroy(true);
    const splide=new Splide(slider,{
      type:'slide',
      perPage:4,
      perMove:1,
      gap:'12px',
      pagination:false,
      arrows:false,
      drag:true,
      breakpoints:{1024:{perPage:3},768:{perPage:2},480:{perPage:2}}
    });
    splide.mount();
    slider._splide=splide;

    setTimeout(initRecentFlickity,600);
  }
  initSplide();
}
*/
async function RV_mountOne(root) {
  if (!root) return;
  const listEl = root.querySelector('.cp-new-recs_list');
  if (!listEl) return;

  // Always start fresh
  listEl.innerHTML = '';

  let handles = RV_readHandles().filter(Boolean);
  const current = (window.meta && window.meta.product && window.meta.product.handle) || null;
  if (current) handles = handles.filter(h => h !== current);
  handles = Array.from(new Set(handles)).slice(0, 20);

  if (!handles.length) {
    root.style.display = 'none';
    return;
  }

  const cards = await Promise.all(
    handles.map(h =>
      fetch(`/products/${encodeURIComponent(h)}?view=recent-card`, { credentials: 'same-origin' })
        .then(r => (r.ok ? r.text() : null))
        .catch(() => null)
    )
  );

  let added = 0;
  cards.forEach(html => {
    try {
      // Skip junk responses (like Clarity script or full HTML)
      if (!html || html.includes('<script') || html.includes('<html')) return;

      const tmp = document.createElement('div');
      tmp.innerHTML = html.trim();
      const cardNode = tmp.firstElementChild;
      if (!cardNode) return;

      const li = document.createElement('li');
      li.className = 'splide__slide';
      li.appendChild(cardNode);
      listEl.appendChild(li);
      added++;
    } catch (err) {
      console.error('[RV] error building card', err);
    }
  });

  // ✅ Toggle visibility properly
  if (added > 0) {
    root.style.display = ''; // show section
  } else {
    root.style.display = 'none'; // hide if no valid cards
    return;
  }

  // Mount Splide carousel
  (function mountSlider() {
    if (!window.Splide) { setTimeout(mountSlider, 100); return; }
    const sliderRoot = root.querySelector('.splide');
    if (!sliderRoot) return;

    if (sliderRoot._splide) {
      try { sliderRoot._splide.destroy(true); } catch (e) {}
      sliderRoot._splide = null;
    }

    const inst = new Splide(sliderRoot, {
      type: 'slide',
      perPage: 5,
      perMove: 1,
      gap: '20px',
      arrows: true,
      pagination: false,
      drag: true,
      rewind: false,
      breakpoints: {
        1024: { perPage: 4 },
        991: { perPage: 3 },
        768: { perPage: 2 },
        480: { perPage: 2 },
      },
    });

    inst.mount();
    sliderRoot._splide = inst;

    // Initialize Flickity inside product images
    waitForElement(
      '.cp-new-recentview-wrap .plp-product-imgs-group.has-slider:not(.flickity-enabled)',
      initRecentSliders
    );
  })();
}

/* === Mount all sections === */
function RV_mountAll(){
  document.querySelectorAll('.cp-new-recentview-wrap').forEach(RV_mountOne);
}

/* === Track current product === */
(function trackCurrentProduct(){
  const handle=window.meta?.product?.handle;
  if(handle) RV_saveHandle(handle);
})();

/* === Init === */
(function initRV(){
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',RV_mountAll);
  else RV_mountAll();
  ['shopify:section:load','ajaxProduct:added','cart:updated'].forEach(e=>document.addEventListener(e,RV_mountAll));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["diwali-collection"]) return;
  try {
    
  // Helper function to wait for elements in dynamic environments
  function waitForElement(selector, callback, timeout = 10000) {
    const start = Date.now();
    const observer = new MutationObserver(() => {
      const el = document.querySelector(selector);
      if (el) {
        observer.disconnect(); // Stop observing once the element is found
        callback(el); // Call the callback with the element
      } else if (Date.now() - start > timeout) {
        observer.disconnect(); // Stop observing after the timeout
        console.error(`Element not found after ${timeout}ms: ${selector}`);
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
    // Also check immediately in case the element is already present
    const el = document.querySelector(selector);
    if (el) {
      observer.disconnect();
      callback(el);
    }
  }
  // Function to remove the 'style' attribute and keep it removed
  function removeStyleAttribute(element) {
    // Initial removal of 'style' attribute
    element.removeAttribute('style');
    // Re-observe the element to remove the 'style' attribute if added again
    const observer = new MutationObserver(() => {
      if (element.hasAttribute('style')) {
        element.removeAttribute('style');
      }
    });
    // Observe for attribute changes
    observer.observe(element, {
      attributes: true,
      attributeFilter: ['style'], // Only watch for 'style' attribute changes
    });
  }
  // Use the waitForElement function to remove the 'style' attribute
  waitForElement(".whatmore-base .whatmore-widget-container .whatmore-carousel-events > div:first-child > p", function(element) {
    removeStyleAttribute(element); // Remove the 'style' attribute and re-observe it
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["diwali-collectionlist-tiles"] && !Shopify.designMode) return;
  try {
    

  function initCollectionSliders() {
    document.querySelectorAll('.selected-collcetion-products .plp-product-imgs-group.has-slider')
      .forEach(slider => {
        if (!slider.flickityInstance) {
          const flkty = new Flickity(slider, {
            cellAlign: 'left',
            contain: true,
            pageDots: true,
            prevNextButtons: false, // optional for PLP thumbnails
            draggable: true,
            imagesLoaded: true   // 👈 ensures layout waits for images
          });
          slider.flickityInstance = flkty;

          // 👇 Safety refresh when all images inside slider load
          const imgs = slider.querySelectorAll("img");
          let loadedCount = 0;
          imgs.forEach(img => {
            if (img.complete) {
              loadedCount++;
            } else {
              img.addEventListener("load", () => {
                loadedCount++;
                if (loadedCount === imgs.length) {
                  flkty.resize();
                }
              });
              img.addEventListener("error", () => {
                loadedCount++;
                if (loadedCount === imgs.length) {
                  flkty.resize();
                }
              });
            }
          });

          // If they were all already cached
          if (loadedCount === imgs.length) {
            flkty.resize();
          }
        }
      });
  }
  function destroyCollectionFlicktySlider() {
    return new Promise(resolve => {
      const sliders = document.querySelectorAll(".selected-collcetion-products .plp-product-imgs-group.has-slider");
      sliders.forEach(slider => {
        if (slider.flickityInstance) {
          slider.flickityInstance.destroy();
          slider.flickityInstance = null;
        }
      });
      resolve("destroyed");
    });
  }

  // Initial run after DOM is ready
  document.addEventListener("DOMContentLoaded", function() {
    initCollectionSliders();
  });

    document.addEventListener('DOMContentLoaded', function () {
    const showMoreBtn = document.getElementById('showMoreBtn') || document.getElementById('showMoreBtns');
    
    if (showMoreBtn) {
        showMoreBtn.addEventListener('click', function () {
        const productSection = showMoreBtn.closest('.selected-collcetion-products');
        
        if (productSection) {
            const hiddenProductCards = productSection.querySelectorAll('.hidden-product');
            
            hiddenProductCards.forEach(card => {
            card.classList.remove('hidden-product'); // Corrected here
            card.style.display = 'block';
            });
            
            showMoreBtn.style.display = 'none';
            
            // Destroy and re-initialize Flickity slider
            destroyCollectionFlicktySlider()
            .then(() => {
                initCollectionSliders();
            })
            .catch(err => console.error("Flickity reset failed:", err));
        }
        });
    }
    });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["diwali-product-recommendations"] && !Shopify.designMode) return;
  try {
    
/* ========= CONFIG / UTIL ========= */
(function () {
  // Global "once" guards (protects from VWO/eleReady/multiple script includes)
  window.__CP_Diwali = window.__CP_Diwali || { innerInit: false, outerInit: false };

  // Simple debounce
  function debounce(fn, wait) {
    let t;
    return function () {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, arguments), wait);
    };
  }

  // Equal height for product cards
  function equalizeCardHeights() {
    const cards = document.querySelectorAll('.diwali-recommendations-list .grid-product__content');
    if (!cards.length) return;

    // reset then compute tallest
    let maxH = 0;
    cards.forEach(card => {
      //card.style.height = 'auto';
      card.style.minHeight = 'auto';
    });
    cards.forEach(card => {
      const h = card.offsetHeight;
      if (h > maxH) maxH = h;
    });
    // apply tallest
    cards.forEach(card => {
      //card.style.height = `${maxH}px`;
      card.style.minHeight = `${maxH}px`;
    });
  }

  /* ========= INNER IMAGE SLIDERS ========= */
  function initCollectionSliders() {
    // If some other script re-calls this, we still gate per-element via flickityInstance
    document.querySelectorAll('.diwali-recommendations-list .plp-product-imgs-group.has-slider').forEach(slider => {
      if (slider.flickityInstance) return;

      const flkty = new Flickity(slider, {
        cellAlign: 'left',
        contain: true,
        pageDots: true,
        prevNextButtons: false, // thumbnails
        draggable: true,
        imagesLoaded: true
      });
      slider.flickityInstance = flkty;

      // When inner slider is ready/changes, keep heights in sync
      flkty.on('ready', equalizeCardHeights);
      flkty.on('change', equalizeCardHeights);
      flkty.on('settle', equalizeCardHeights);

      // Safety refresh when all images inside slider load
      const imgs = slider.querySelectorAll('img');
      let loadedCount = 0;

      function maybeResize() {
        loadedCount++;
        if (loadedCount === imgs.length) {
          flkty.resize();
          equalizeCardHeights();
        }
      }

      imgs.forEach(img => {
        if (img.complete) {
          maybeResize();
        } else {
          img.addEventListener('load', maybeResize, { once: true });
          img.addEventListener('error', maybeResize, { once: true });
        }
      });

      // If cached
      if (loadedCount === imgs.length) {
        flkty.resize();
        equalizeCardHeights();
      }
    });

    // mark once (helps in debug / future guards)
    window.__CP_Diwali.innerInit = true;
  }

  function destroyCollectionFlicktySlider() {
    return new Promise(resolve => {
      document.querySelectorAll('.diwali-recommendations-list .plp-product-imgs-group.has-slider').forEach(slider => {
        if (slider.flickityInstance) {
          slider.flickityInstance.destroy();
          slider.flickityInstance = null;
        }
      });
      resolve('destroyed');
    });
  }

  /* ========= OUTER RECOMMENDATIONS CAROUSEL ========= */
  function initDiwaliCarousel() {
    const carousel = document.querySelector('#diwali-collectionlist-recommend');
    if (!carousel || carousel.flickityInstance) return;

    // responsive groupCells only when breakpoint actually changes
    const currentGroup = window.innerWidth < 768 ? 2 : 4;
    const flkty = new Flickity(carousel, {
      cellAlign: 'left',
      contain: true,
      wrapAround: true,
      pageDots: false,
      prevNextButtons: true,
      imagesLoaded: true,
      draggable: true,
      groupCells: currentGroup
    });

    carousel.flickityInstance = flkty;
    carousel.__cpGroupCells = currentGroup; // remember for resize logic

    // keep equal heights aligned with motion
    flkty.on('ready', equalizeCardHeights);
    flkty.on('change', equalizeCardHeights);
    flkty.on('settle', equalizeCardHeights);

    window.__CP_Diwali.outerInit = true;
  }

  /* ========= INITIAL RUNS ========= */
  document.addEventListener('DOMContentLoaded', function () {
    // Guard DOMContentLoaded double-fires by other scripts
    if (!window.Flickity) {
      // If Flickity not yet present, poll briefly
      (function waitForFlickity(tries = 0) {
        if (window.Flickity) {
          initCollectionSliders();
          initDiwaliCarousel();
          equalizeCardHeights();
        } else if (tries < 30) {
          setTimeout(() => waitForFlickity(tries + 1), 200);
        }
      })();
    } else {
      initCollectionSliders();
      initDiwaliCarousel();
      equalizeCardHeights();
    }
  });

  /* ========= RESIZE (only re-init if breakpoint changes) ========= */
  window.addEventListener('resize', debounce(() => {
    const carousel = document.querySelector('#diwali-collectionlist-recommend');
    const desiredGroup = window.innerWidth < 768 ? 2 : 4;

    if (carousel?.flickityInstance) {
      if (carousel.__cpGroupCells !== desiredGroup) {
        // only rebuild when we actually cross mobile/desktop boundary
        carousel.flickityInstance.destroy();
        carousel.flickityInstance = null;
        initDiwaliCarousel();
      } else {
        // otherwise just fix layout + equal heights
        carousel.flickityInstance.resize();
        equalizeCardHeights();
      }
    } else {
      // if destroyed somehow, re-init safely
      initDiwaliCarousel();
    }

    // inner sliders can keep their instance; just resize & re-equalize
    document.querySelectorAll('.diwali-recommendations-list .plp-product-imgs-group.has-slider').forEach(slider => {
      if (slider.flickityInstance) slider.flickityInstance.resize();
    });
    equalizeCardHeights();
  }, 200));

  /* ========= SHOPIFY SECTION HOOKS (prevents repeated init-on-appear) ========= */
  document.addEventListener('shopify:section:load', function (e) {
    // When theme editor or dynamic load swaps the section DOM
    const section = e.target;
    if (!section.querySelector || !section.querySelector('#diwali-collectionlist-recommend')) return;

    destroyCollectionFlicktySlider().then(() => {
      initCollectionSliders();
      initDiwaliCarousel();
      equalizeCardHeights();
    });
  });

  document.addEventListener('shopify:section:unload', function (e) {
    const section = e.target;
    if (!section.querySelector || !section.querySelector('#diwali-collectionlist-recommend')) return;

    const carousel = section.querySelector('#diwali-collectionlist-recommend');
    if (carousel?.flickityInstance) {
      carousel.flickityInstance.destroy();
      carousel.flickityInstance = null;
    }
    destroyCollectionFlicktySlider();
  });

  // As a final safety for async badges/reviews injecting later (Judge.me etc.)
  window.addEventListener('load', equalizeCardHeights);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["diwali-recommended"] && !Shopify.designMode) return;
  try {
    

/* === Utility: Wait for element to appear === */
function waitForElement(selector, callback, checkInterval = 200, timeout = 8000) {
  const start = Date.now();
  const timer = setInterval(() => {
    const els = document.querySelectorAll(selector);
    if (els.length > 0) {
      clearInterval(timer);
      callback(els);
    } else if (Date.now() - start > timeout) {
      clearInterval(timer);
      console.warn('[waitForElement] Timeout: no match for', selector);
    }
  }, checkInterval);
}


/* === Load Splide & Flickity === */
(function ensureLibraries() {
  if (!window.Splide) {
    const s=document.createElement('script');
    s.src='https://cdn.jsdelivr.net/npm/@splidejs/splide@4.1.4/dist/js/splide.min.js';
    document.head.appendChild(s);
    const c=document.createElement('link');
    c.rel='stylesheet';
    c.href='https://cdn.jsdelivr.net/npm/@splidejs/splide@4.1.4/dist/css/splide.min.css';
    document.head.appendChild(c);
  }
  if (!window.Flickity) {
    const f=document.createElement('script');
    f.src='https://cdn.jsdelivr.net/npm/flickity@2.3.0/dist/flickity.pkgd.min.js';
    document.head.appendChild(f);
    const fcss=document.createElement('link');
    fcss.rel='stylesheet';
    fcss.href='https://cdn.jsdelivr.net/npm/flickity@2.3.0/dist/flickity.min.css';
    document.head.appendChild(fcss);
  }
})();

/* === Helpers === */
function RV_readHandles(){
  try { return JSON.parse(localStorage.getItem('cp_recent_handles')||'[]'); }
  catch(e){ return []; }
}
function RV_saveHandle(handle){
  if(!handle) return;
  let list=RV_readHandles();
  list=[handle,...list.filter(h=>h!==handle)];
  localStorage.setItem('cp_recent_handles',JSON.stringify(list.slice(0,20)));
}

/* === Flickity Init === 
function initRecentFlickity(){
  document.querySelectorAll('.plp-product-imgs-group.has-slider:not(.flickity-enabled)').forEach(el=>{
    if(window.Flickity && !el.flickityInstance){
      el.flickityInstance=new Flickity(el,{
        cellAlign:'left',
        contain:true,
        pageDots:true,
        prevNextButtons:false,
        wrapAround:true
      });
    }
  });
}
*/
/* === Initialize Flickity sliders inside product cards === */
function initRecentSliders(elements) {
  if (!window.Flickity) {
    console.warn('[initRecentSliders] Flickity not loaded yet.');
    setTimeout(() => initRecentSliders(elements), 300);
    return;
  }

  elements.forEach(slider => {
    if (slider.classList.contains('flickity-enabled')) return;
    try {
      new Flickity(slider, {
        cellAlign: 'left',
        contain: true,
        pageDots: true,
        prevNextButtons: true,
        adaptiveHeight: true,
        wrapAround: false,
        groupCells: false,
      });
      console.debug('[Flickity] initialized on', slider);
    } catch (err) {
      console.error('[Flickity] init error:', err);
    }
  });
}

/* === Build Recently Viewed === 
async function RV_mountOne(root){
  const list=root.querySelector('.cp-new-recs_list');
  if(!list) return;
  list.innerHTML='';
  let handles=RV_readHandles().filter(Boolean);
  const current=window.meta?.product?.handle||null;
  if(current) handles=handles.filter(h=>h!==current);
  handles=[...new Set(handles)].slice(0,20);

  if(!handles.length){ root.style.display='none'; return; }
  root.style.display='';

  const cards=await Promise.all(handles.map(async h=>{
    try{
      const res=await fetch(`/products/${encodeURIComponent(h)}?view=recent-card`);
      if(!res.ok) return null;
      return await res.text();
    }catch{return null;}
  }));

    let count=0;
    cards.forEach(html => {
        if (!html || html.includes('<script') || html.includes('<html')) return;
        const tmp = document.createElement('div');
        tmp.innerHTML = html.trim();
        const card = tmp.firstElementChild;
        if (!card) return;
        const li = document.createElement('li');
        li.className = 'splide__slide';
        li.appendChild(card);
        list.appendChild(li);
    });


  if(!count){ root.style.display='none'; return; }

  // === Outer Splide ===
  function initSplide(){
    if(!window.Splide) return setTimeout(initSplide,100);
    const slider=root.querySelector('.splide');
    if(!slider) return;
    if(slider._splide) slider._splide.destroy(true);
    const splide=new Splide(slider,{
      type:'slide',
      perPage:4,
      perMove:1,
      gap:'12px',
      pagination:false,
      arrows:false,
      drag:true,
      breakpoints:{1024:{perPage:3},768:{perPage:2},480:{perPage:2}}
    });
    splide.mount();
    slider._splide=splide;

    setTimeout(initRecentFlickity,600);
  }
  initSplide();
}
*/
async function RV_mountOne(root) {
  if (!root) return;
  const listEl = root.querySelector('.cp-new-recs_list');
  if (!listEl) return;

  // Always start fresh
  listEl.innerHTML = '';

  let handles = RV_readHandles().filter(Boolean);
  const current = (window.meta && window.meta.product && window.meta.product.handle) || null;
  if (current) handles = handles.filter(h => h !== current);
  handles = Array.from(new Set(handles)).slice(0, 20);

  if (!handles.length) {
    root.style.display = 'none';
    return;
  }

  const cards = await Promise.all(
    handles.map(h =>
      fetch(`/products/${encodeURIComponent(h)}?view=recent-card`, { credentials: 'same-origin' })
        .then(r => (r.ok ? r.text() : null))
        .catch(() => null)
    )
  );

  let added = 0;
  cards.forEach(html => {
    try {
      // Skip junk responses (like Clarity script or full HTML)
      if (!html || html.includes('<script') || html.includes('<html')) return;

      const tmp = document.createElement('div');
      tmp.innerHTML = html.trim();
      const cardNode = tmp.firstElementChild;
      if (!cardNode) return;

      const li = document.createElement('li');
      li.className = 'splide__slide';
      li.appendChild(cardNode);
      listEl.appendChild(li);
      added++;
    } catch (err) {
      console.error('[RV] error building card', err);
    }
  });

  // ✅ Toggle visibility properly
  if (added > 0) {
    root.style.display = ''; // show section
  } else {
    root.style.display = 'none'; // hide if no valid cards
    return;
  }

  // Mount Splide carousel
  (function mountSlider() {
    if (!window.Splide) { setTimeout(mountSlider, 100); return; }
    const sliderRoot = root.querySelector('.splide');
    if (!sliderRoot) return;

    if (sliderRoot._splide) {
      try { sliderRoot._splide.destroy(true); } catch (e) {}
      sliderRoot._splide = null;
    }

    const inst = new Splide(sliderRoot, {
      type: 'slide',
      perPage: 4,
      perMove: 1,
      gap: '12px',
      arrows: true,
      pagination: false,
      drag: true,
      rewind: false,
      breakpoints: {
        1024: { perPage: 4 },
        768: { perPage: 2 },
        480: { perPage: 2 },
      },
    });

    inst.mount();
    sliderRoot._splide = inst;

    // Initialize Flickity inside product images
    waitForElement(
      '.cp-new-recentview-wrap .plp-product-imgs-group.has-slider:not(.flickity-enabled)',
      initRecentSliders
    );
  })();
}

/* === Mount all sections === */
function RV_mountAll(){
  document.querySelectorAll('.cp-new-recentview-wrap').forEach(RV_mountOne);
}

/* === Track current product === */
(function trackCurrentProduct(){
  const handle=window.meta?.product?.handle;
  if(handle) RV_saveHandle(handle);
})();

/* === Init === */
(function initRV(){
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',RV_mountAll);
  else RV_mountAll();
  ['shopify:section:load','ajaxProduct:added','cart:updated'].forEach(e=>document.addEventListener(e,RV_mountAll));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["navaratri-editorial-picks"] && !Shopify.designMode) return;
  try {
    
  function waitForElement(sel, cb) {
    const i = setInterval(() => {
      const el = document.querySelector(sel);
      if (el) { clearInterval(i); cb(el); }
    }, 100);
  }

  function forceOpenCartUI() {
    try {
      if (typeof updateMiniCartSection === 'function') updateMiniCartSection();

      // Shiprocket
      if (window.shiprocketSmartCart?.refresh) window.shiprocketSmartCart.refresh();
      const srRoot = document.getElementById('shiprocket-smart-cart-root');
      if (srRoot) srRoot.click();

      // Common theme drawers
      const triggers = [
        '.js-drawer-open-cart',
        '[data-drawer-trigger="cart"]',
        '.site-header__cart',
        '.header__icon--cart'
      ];
      for (const t of triggers) {
        const el = document.querySelector(t);
        if (el) { el.click(); break; }
      }

      // Direct drawer objects many themes expose
      if (window.theme?.cartDrawer?.open) window.theme.cartDrawer.open();
      if (window.Shopify?.theme?.cartDrawer?.open) window.Shopify.theme.cartDrawer.open();
      if (typeof window.openCartDrawer === 'function') window.openCartDrawer();

      // Visual fallback
      waitForElement('cart-drawer, .cart-drawer, #CartDrawer', d => d.classList.add('is-open'));
    } catch (e) {
      console.error('Cart-open fallback error', e);
    }
  }

  document.addEventListener('click', async e => {
    const btn = e.target.closest('.add-to-cart-button');
    if (!btn) return;
    e.preventDefault();

    const productId = btn.dataset.productId;
    const variantSel = document.querySelector(`.variant-selector[data-product-id="${productId}"]`);
    const variantId  = variantSel ? variantSel.value : btn.dataset.variantId;

    if (!variantId) { alert('Please select a size.'); return; }

    try {
      const r = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });
      if (!r.ok) throw new Error('Add-to-cart failed');
      await r.json();

      forceOpenCartUI(); // 👈 the separated function

    } catch (err) {
      console.error(err);
      alert('Error adding to cart.');
    }
  });
  

  document.addEventListener('DOMContentLoaded', function () {
    const showMoreBtn = document.getElementById('showMoreBtn') || document.getElementById('showMoreBtns');
    if (showMoreBtn) {
      showMoreBtn.addEventListener('click', () => {
        document.querySelectorAll('.hidden-product').forEach(el => {
          el.style.display = 'block';
        });
        showMoreBtn.style.display = 'none';
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed-section"] && !Shopify.designMode) return;
  try {
    
  
// Utility: Wait for element to appear in DOM
function waitForRecentElement(selector, callback) {
  const interval = setInterval(() => {
    const el = document.querySelector(selector);
    if (el) {
      clearInterval(interval);
      callback(el);
    }
  }, 100);
}

function initSliders() {
    var sliders = document.querySelectorAll('.cp-recent-wrap .plp-product-imgs-group.has-slider:not(.flickity-enabled)');
    sliders.forEach(function (slider) {
        if (!slider.flickityInstance) {
        slider.flickityInstance = new Flickity(slider, {
            cellAlign: 'left',
            contain: true,
            pageDots: true
        });
        }
    });
}
waitForRecentElement('.cp-recent-wrap .plp-product-imgs-group.has-slider:not(.flickity-enabled)', initSliders);


  } catch(e) { console.error(e); }
})();
})();
